import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/registro',
    name: 'Registro',
    component: () => import('../views/RegistroAsistencia.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/AdminPanel.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/cargos-equipos',
    name: 'CargosEquipos',
    component: () => import('../views/CargosEquipos.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/reportes',
    name: 'Reportes',
    component: () => import('../views/Reportes.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/configuracion',
    name: 'Configuracion',
    component: () => import('../views/Configuracion.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/usuario',
    name: 'Usuario',
    component: () => import('../views/UsuarioPanel.vue'),
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login');
  } else if (to.meta.requiresGuest && authStore.isAuthenticated) {
    next('/registro');
  } else if (to.meta.requiresAdmin && !authStore.isAdmin) {
    next('/usuario');
  } else {
    next();
  }
});

export default router;